import { toast } from "react-toastify";
import { Slide } from "react-toastify";

/**
 * Helper functions for displaying toast notifications
 * These are more subtle than Swal modals - small notifications that appear in the corner
 */

export const notification = {
  success: (message, options = {}) => {
    return toast.success(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      transition: Slide,
      ...options,
    });
  },

  error: (message, options = {}) => {
    return toast.error(message, {
      position: "bottom-center",
      autoClose: 4000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      transition: Slide,
      ...options,
    });
  },

  info: (message, options = {}) => {
    return toast.info(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",

      ...options,
    });
  },

  warning: (message, options = {}) => {
    return toast.warning(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      ...options,
    });
  },
};
